import { ConfigValues } from "../Entities/ConfigValues";
import { RouteUrls } from "../../RouteUrls";
import { WellKnownApplicationID } from "../ApplicationID";
import { MgmtBrandId } from "../Entities/Brand";

/** Configuration for the dev environment of our primary brand. */
export const BaseConfig: ConfigValues = {

    ApiBaseUrl: "https://mgmt.mtidev.net/",
    ApiVersionSegments: "api/v1/",
    AppInsightsConnectionString: "InstrumentationKey=0dc824d7-207c-4d4c-9c73-f9bb343bf9f8;IngestionEndpoint=https://southeastasia-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/;ApplicationId=293b8c25-5db4-411d-8864-18aec62a229a",
    HomeUrl: "https://www.13cabs.com.au/",
    InternalApplicationId: WellKnownApplicationID.OneThreeCabs,
    IsTestModeSupported: true,
    StaticContentBaseUrl: "https://book-web-cdn-dev.mtidev.net/",
    TrackingLinkBaseUrl: "https://13orange2-dev.azurewebsites.net/b/",
    Payment: {
        MpsEndpoint: "https://cabcharge-dev.azure-api.net/card-rego-service/site",
        PaymentFaqLink: null
    },
    Auth0: {
        ClientDomain: "13cabsdevtest.au.auth0.com",
        ClientId: "pHQa1jZFqkfGujVV3z4dAmM6DqD9FNXY",
        CustomDomain: "auth-dev.13cabs.com.au",
        Connection: "13CABS-Public-Users"
    },
    WebsiteTitle: "13cabs - we'll get you there",
    BrandColour: "#ff6d1f",
    BrandName: "13cabs",
    BrandContactNumber: "13 2227",
    PrivacyUrl: RouteUrls.PrivacyPolicy,
    DefaultToSilverservice: false,
    GoogleTagManagerKey: "GTM-KNTQ4RQ",
    ExternalContactUsUrl: null,
    DownloadMobileAppPageUrl: "https://www.13cabs.com.au/app/",
    MgmtBrandId: MgmtBrandId.OneThreeCabs,
    DefaultLocation: {
        displayName: "New South Wales",
        geoPoint: { latitude: -33.8473567, longitude: 150.6517881 },
        isGeopointServiced: true,
        isStateServiced: true,
        isValid: true,
        stateCode: "nsw",
    },
    AllowedCountryCodes: ["AU"],
    BookingContactNumber: "13 2227",
    DriverConnectNumber: "1300694752",
    GoogleMapsApiKey: "AIzaSyCESHkkfh1pnvJ_7CGcYUA7U4Z8RWEo3ug",
    GooglePayEnvironment: "TEST",
};